import React from 'react';
import { useEffect } from 'react'
import dentalBanner from './../../../../../assets/images/blogs/HydraFacial blog 22-09-25.webp';
import { useNavigate } from 'react-router-dom';
import favicon from "./../../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const HydrafacialBlog = () => {
  let navigate = useNavigate()
    useEffect(() => {
         document.title = "HydraFacial Treatment Benefits | Best Skin Care Clinic in Bangalore & Chennai";
         const metaDescription = document.querySelector("meta[name='description']");
         if (metaDescription) {
           metaDescription.setAttribute(
             "content",
             "Discover the amazing benefits of HydraFacial treatment for glowing, healthy skin. Visit H-Cura Skin Clinic in Bangalore & Chennai for professional HydraFacial services."
           );
         }
         const metaKeywords = document.querySelector("meta[name='keywords']");
         if (metaKeywords) {
           metaKeywords.setAttribute(
             "content",
             "HydraFacial treatment, skin care, facial treatment, glowing skin, skin clinic Bangalore, skin clinic Chennai, dermatology, skincare routine, facial rejuvenation, H-Cura Skin Clinic, hydrating facial, skin cleansing, anti-aging treatment, best facial treatment, professional skincare"
           );
         }
          // Set canonical link
          const existingCanonical = document.querySelector("link[rel='canonical']");
          if (existingCanonical) {
            existingCanonical.setAttribute("href", "https://www.h-cura.com/hydrafacial-dull-to-dazzling-restore-radiance");
          } else {
            const canonicalLink = document.createElement("link");
            canonicalLink.setAttribute("rel", "canonical");
            canonicalLink.setAttribute("href", "https://www.h-cura.com/hydrafacial-dull-to-dazzling-restore-radiance");
            document.head.appendChild(canonicalLink);
          }
          // Set favicon
       const existingFavicon = document.querySelector("link[rel='icon']");
       if (existingFavicon) {
         existingFavicon.setAttribute("href", favicon);
       } else {
         const faviconLink = document.createElement("link");
         faviconLink.setAttribute("rel", "icon");
         faviconLink.setAttribute("type", "image/x-icon");
         faviconLink.setAttribute("href", favicon);
         document.head.appendChild(faviconLink);
       }
       }, []);
  

  const handleBookAppointment = () => {
    navigate('/bookconsultation'); // Use navigate to redirect to the booking page
  
  };


   const handleDownloadPdf = () => {
  const input = document.querySelector('.dentalblog'); // Use the main container class
  
  html2canvas(input, { 
    scale: 2,
    useCORS: true,
    logging: false 
  }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const imgWidth = 210;
    const pageHeight = 297;
    const imgHeight = canvas.height * imgWidth / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
    
    pdf.save('H-Cura_Hydrafacial_Treatment.pdf');
  }).catch(error => {
    console.error('Error generating PDF:', error);
    alert('Failed to generate PDF. Please try again.');
  });
};
  return (
    <>
      <div className="dentalblog">
      <div className="dentalblog-banner">
  <img src={dentalBanner} alt="HydraFacial Treatment Banner" />
  <div className="dentalblog-banner-overlay">
    <h1>The Ultimate Guide to HydraFacial Treatment</h1>
    <h2>Transform Your Skin with Professional Care</h2>
    <button 
      className="dentalblogbook-appointment-btn" 
      onClick={handleBookAppointment}
    >
      Book Appointment
    </button>
  </div>
</div>

        
        <div className="dentalblog-container">
          <div className="dentalblog-intro">
            <p>Imagine having radiant, glowing skin that looks refreshed and youthful without any downtime. That's exactly what HydraFacial treatment offers – a revolutionary skincare solution that's taking the beauty world by storm.</p>
            <p>At H-Cura Multispeciality Clinic, with locations in Jayanagar, Bangalore, and Gerugambakkam, Chennai, we're proud to offer this cutting-edge treatment that delivers instant, visible results for all skin types.</p>
          </div>
          
          <div className="dentalblog-section">
            <h2>✨ What is HydraFacial Treatment?</h2>
            <p>HydraFacial is a non-invasive, multi-step facial treatment that deeply cleanses, exfoliates, extracts impurities, and hydrates the skin while providing antioxidant protection. Using advanced Vortex-Fusion technology, HydraFacial delivers instant, visible results, reduces dullness, and restores a radiant, healthy glow with no irritation or downtime.</p>
            <p>This revolutionary treatment is suitable for all skin types and addresses multiple skin concerns in just one session, making it the perfect choice for busy professionals in Bangalore and Chennai.</p>
          </div>
          
          <div className="dentalblog-tips">
            <div className="dentalblog-tip-card">
              <h3>🌟 1. Instant Glow and Radiance</h3>
              <p>The HydraFacial treatment immediately improves skin texture and tone, giving you that coveted "red carpet glow" right after your session. Your skin will look brighter, smoother, and more youthful.</p>
              <p className="tip-highlight">✅ Perfect For: Special occasions, weddings, or when you want to look your absolute best in Bangalore's social scene.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>💧 2. Deep Cleansing and Hydration</h3>
              <p>The treatment deeply cleanses pores while simultaneously infusing the skin with intensive moisturizers and nourishing peptides. This dual action leaves your skin feeling incredibly soft and hydrated.</p>
              <p className="tip-highlight">✅ Ideal For: Chennai's humid climate that can leave skin feeling congested and dehydrated.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>🎯 3. Reduces Fine Lines and Wrinkles</h3>
              <p>HydraFacial's anti-aging serums help reduce the appearance of fine lines and wrinkles, promoting collagen production for firmer, more youthful-looking skin.</p>
              <p className="tip-highlight">✅ Anti-Aging Tip: Regular HydraFacial sessions at our Jayanagar clinic can help maintain youthful skin as you age gracefully.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>🌿 4. Gentle Yet Effective for All Skin Types</h3>
              <p>Unlike harsh chemical peels or abrasive treatments, HydraFacial is gentle enough for sensitive skin while being effective for oily, dry, or combination skin types.</p>
              <p className="tip-highlight">✅ Sensitive Skin Solution: Our dermatologists in Gerugambakkam, Chennai, customize each treatment for your specific skin needs.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>⚡ 5. No Downtime Required</h3>
              <p>One of the biggest advantages of HydraFacial is that you can return to your normal activities immediately after treatment. No peeling, redness, or recovery time needed.</p>
              <p className="tip-highlight">✅ Lunch Break Treatment: Perfect for busy professionals who want great skin without disrupting their schedule.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>🎨 6. Customizable Treatment Options</h3>
              <p>HydraFacial can be customized with specialized serums and boosters to target specific concerns like hyperpigmentation, acne, or signs of aging.</p>
              <p className="tip-highlight">✅ Personalized Care: Our skin specialists create a treatment plan tailored to your unique skin goals and concerns.</p>
            </div>
            
            <div className="dentalblog-tip-card">
              <h3>💎 7. Long-lasting Results with Regular Sessions</h3>
              <p>While you'll see immediate improvements, regular HydraFacial treatments provide cumulative benefits, leading to healthier, more resilient skin over time.</p>
              <p>At H-Cura Multispeciality Clinic, we recommend monthly sessions to maintain optimal skin health and that enviable glow that turns heads in Bangalore and Chennai.</p>
            </div>
          </div>
          
          <div className="dentalblog-cta">
            <h2>📞 Book Your HydraFacial Today</h2>
            <p>👉 Call: <a href="tel:+918870001377">+91 88700 01377</a></p>
            <p>📍 Visit us in Bangalore (Jayanagar) or Chennai (Tambaram, Gerugambakkam & Valasaravakkam)</p>
          </div>
          
          <div className="dentalblog-summary">
            <h2>🌟 Quick Summary: Why Choose HydraFacial?</h2>
            <ul>
              <li>✅ Instant visible results with immediate glow</li>
              <li>✅ Deep cleansing and intense hydration</li>
              <li>✅ Reduces fine lines and improves skin texture</li>
              <li>✅ Suitable for all skin types, including sensitive skin</li>
              <li>✅ No downtime or recovery period needed</li>
              <li>✅ Customizable treatments for specific skin concerns</li>
              <li>✅ Long-lasting results with regular maintenance</li>
            </ul>
            <p>HydraFacial isn't just a facial treatment – it's a complete skin transformation experience that delivers the healthy, glowing skin you've always wanted.</p>
          </div>
          
          <div className="dentalblog-testimonials">
            <h2>❤️ Why H-Cura is Your Best Choice for HydraFacial</h2>
            <p>At H-Cura Multispeciality Clinic, our certified dermatologists and skincare specialists provide professional HydraFacial treatments using the latest technology and highest quality serums.</p>
            <div className="testimonial-container">
              <div className="testimonial">
                <p>💬 "I got my HydraFacial at H-Cura Jayanagar before my wedding, and my skin has never looked better! The glow lasted for weeks!" – A happy bride from Bangalore</p>
              </div>
              <div className="testimonial">
                <p>💬 "Best skincare treatment I've ever had! The team at H-Cura Gerugambakkam made me feel so comfortable, and the results are amazing." – A satisfied client from Chennai</p>
              </div>
            </div>
          </div>
        </div>
      </div>

       {/* <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Blog as PDF
            </button>
          </div> */}

    </>
  );
};

export default HydrafacialBlog;